"use client";

import React from "react";

import { iconColor } from "./colors";
import { createSVGIcon } from "./createSVGIcon";
import { iconCls } from "./tracking";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=13107%3A358))
 * @trackcomponent
 * @lastsynced 2026-10-29T13:54:33.522Z
 * @optimized using svgo:^3.3.4
 */
export const Unlock = createSVGIcon(
  <path
    d="M3.43 9.432h17.143v13.714H3.43zm7.714 6.857a.857.857 0 1 0 1.715 0 .857.857 0 0 0-1.715 0ZM7.759 2.617A6 6 0 0 1 18 6.86v2.571"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "Unlock",
  {
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
